<template>
  <div class="ViewPromo -sibtire" ref="container">
    <view-top :title="title" :desc="desc" :id="id"></view-top>
    <view-how-cards class="ViewPromo__section"></view-how-cards>
    <view-promo-products
      :id="id"
      :productId="productId"
      class="ViewPromo__section"
    ></view-promo-products>

    <div class="ViewPromo__section">
      <div class="ViewDieselInfo">
        <div class="ViewDieselInfo__row">
          <div class="ViewDieselInfo__col">
            <div class="ViewDieselInfo__content">
              <h2 class="ViewDieselInfo__title">{{ name }}</h2>
              <div class="ViewDieselInfo__inn">ИНН {{ inn }}</div>
              <div class="ViewDieselInfo__text app-typography">
                <h4>О компании:</h4>
                <p>
                  Мы специализированная компания, деятельность которой
                  направлена на оптовую реализацию нефтепродуктов — бензина,
                  дизельного топлива, индустриальных масел, керосина. Доставка
                  по Сибири, Бурятии, Забайкалью. Предоставляем гарантии и
                  сертификаты качества.
                </p>
                <p>
                  Мы обеспечиваем поставки нефтепродуктов с привлечением
                  железнодорожного транспорта и специализированного автопарка.
                  Доставка до потребителя возможна и посредством самовывоза с
                  территории нашей базы.
                </p>
                <p>
                  Мы организовываем свою работу так, чтобы независимо от разных
                  факторов своевременно выполнять свои обязательства.
                </p>
                <p>
                  Сибтайр — это специализированная компания, деятельность
                  которой направлена на оптовую реализацию нефтепродуктов —
                  бензина, дизельного топлива, индустриальных масел, керосина.
                </p>
              </div>
            </div>
          </div>
          <div class="ViewDieselInfo__col">
            <div class="ViewDieselInfo__advantages-wrapper">
              <ul class="ViewPromo__advantages">
                <li class="ViewPromo__advantage">
                  <div class="ViewPromo__advantage-icon">
                    <app-svg-icon
                      name="iphone"
                      class="ViewPromo__advantage-icon-svg"
                    ></app-svg-icon>
                  </div>
                  <div class="ViewPromo__advantage-text">
                    <h4 class="ViewPromo__advantage-title">
                      Данные поставщика
                    </h4>
                    <p>
                      Телефон компании:<br />
                      <strong
                        ><a
                          href="tel:+79025190011"
                          class="ViewPromo__advantage-contact-link"
                          >+7 (902) 519-00-11</a
                        ></strong
                      >
                    </p>
                    <p>
                      Адрес электронной почты:<br />
                      <strong
                        ><a
                          href="mailto:op@sibtire.ru "
                          class="ViewPromo__advantage-contact-link"
                          >op@sibtire.ru
                        </a></strong
                      >
                    </p>
                  </div>
                </li>
                <li class="ViewPromo__advantage">
                  <div class="ViewPromo__advantage-icon">
                    <app-svg-icon
                      name="lock-pin"
                      class="ViewPromo__advantage-icon-svg"
                    ></app-svg-icon>
                  </div>
                  <div class="ViewPromo__advantage-text">
                    <h4 class="ViewPromo__advantage-title">Базисы поставок</h4>
                    <p>
                      <strong>НБ ЮНИКОМ</strong>
                    </p>
                    <p>
                      Россия, Иркутская область, Ангарск, Второй промышленный
                      массив, 34-й квартал
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <view-oil-scheme class="ViewPromo__section"></view-oil-scheme>
    <view-safe-advantages class="ViewPromo__section"></view-safe-advantages>
    <view-advantages class="ViewPromo__section"></view-advantages>
    <view-landing-buttons class="ViewPromo__section"></view-landing-buttons>
  </div>
</template>

<script>
export default {
  name: 'ViewPromo',
  inject: ['responsive'],
  components: {
    ViewPromoProducts: () =>
      import('@/pages/static/components/ViewPromoProducts.vue'),
    ViewSafeAdvantages: () =>
      import('@/pages/static/components/ViewSafeAdvantages'),
    ViewTop: () => import('@/pages/static/components/ViewTop'),
    ViewAdvantages: () => import('@/pages/static/components/ViewAdvantages'),
    ViewOilScheme: () => import('@/pages/static/components/ViewOilScheme'),
    ViewLandingButtons: () =>
      import('@/pages/static/components/ViewLandingButtons'),
    ViewHowCards: () => import('@/pages/static/components/ViewHowCards'),
    AppSvgIcon: () => import('@/components/common/AppSvgIcon'),
  },
  data: () => ({
    title: 'Топливо оптом онлайн от поставщика ООО «Сибтайр»',
    desc: 'на платформе OPEN OIL MARKET',
    id: 738,
    productId: 1218,
    name: 'ООО «Сибтайр»',
    inn: '3801145701 ',
  }),
};
</script>

<style lang="scss">
.-sibtire .ViewPromo__logo-img {
  height: rem(20);
}
</style>
